import { authenticationStore } from '@/store'
import axios, { AxiosRequestConfig } from 'axios'
import { AuthenticationError } from '@/store/entities'
import { AuthenticationUtils } from '@/commons/utils/authentication'

const authenticatedAxios = axios.create({
    headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0'
    }
})

authenticatedAxios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        const token = authenticationStore.resolveAuthorizationToken() || ''
        if (!token) {
            throw new AuthenticationError()
        }
        AuthenticationUtils.refreshSession()
        if (config.headers) {
            config.headers['X-Auth-Token'] = token
        }
        return config
    }
)

export default authenticatedAxios
